<template>
  <div class="nav">
    <div
      v-for="(item, index) in items"
      :key="item.id"
      class="item"
      @click="onItemClickInner(index, item)"
    >
      <div class="s8" :class="item.isSelect ? 'c5' : 't1'">
        {{ item.name }}
        <span class="s4" :class="item.isSelect ? 'c5' : 't3'">{{ item.title }}</span>
      </div>
      <div :class="item.isSelect ? 'sel' : ''" class="ind" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavItem',
  props: {
    items: {
      type: Array
    }
  },
  methods: {
    onItemClickInner(index, item) {
      this.items.forEach(function (it) {
        it.isSelect = false
      })
      item.isSelect = true
      this.$emit('onItemClick', index, item)
    }
  }
}
</script>

<style scoped>
.nav {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 80px;
  justify-content: space-around;
  align-items: center;
}

.nav .item {
  position: relative;
}

.ind {
  height: 6px;
  width: 60%;
  position: absolute;
  left: 20%;
  right: 0px;
  bottom: -15px;
  border-radius: 6px;
}

.sel {
  background: #046bbc;
}
</style>
